export default __webpack_public_path__ + "media/images/crop-pic-9aa0968bc10682b85e6fef33d16c80b7.jpg";